import { Link } from 'react-router-dom'
import { Button } from '@/ui/components/'
import { Badge } from '@/ui/components/'
import type { FeedCard as FeedCardType } from '@/shared/api'
import { PRIORITY_BADGE, FEED_ICON_MAP, PRIORITY_ICON_CHIP } from './feedCardStyles'
import { FeedRow } from './FeedRow'

interface FeedCardProps {
  card: FeedCardType
}

function isExternal(url?: string): boolean {
  return !!url && /^https?:\/\//i.test(url)
}

/**
 * Generic rule-based feed row (next steps, weather, invites, gear/meal needs, polls).
 * AI and event cards have their own components.
 */
export function FeedCard({ card }: FeedCardProps) {
  const priorityBadge = PRIORITY_BADGE[card.priority]
  const external = isExternal(card.actionUrl)

  const subtitle = card.tripName ? (
    <>
      <span className="font-medium text-earth-700 dark:text-earth-300">{card.tripName}</span>
      {' · '}
      {card.body}
    </>
  ) : (
    card.body
  )

  return (
    <FeedRow
      title={card.title}
      subtitle={subtitle}
      icon={FEED_ICON_MAP[card.icon]}
      iconChipClassName={PRIORITY_ICON_CHIP[card.priority]}
      badge={
        priorityBadge ? (
          <Badge variant={priorityBadge.variant} className={priorityBadge.className}>
            {priorityBadge.label}
          </Badge>
        ) : undefined
      }
      action={
        card.actionUrl && card.actionText ? (
          external ? (
            <Button variant="outline" size="sm" asChild>
              <a href={card.actionUrl} target="_blank" rel="noopener noreferrer">
                {card.actionText}
              </a>
            </Button>
          ) : (
            <Button variant="outline" size="sm" asChild>
              <Link to={card.actionUrl}>{card.actionText}</Link>
            </Button>
          )
        ) : undefined
      }
    />
  )
}
